import React, { useState, useEffect } from "react";
import SideBarComponent from "../../components/SideBarComponent";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { MdOutlineWorkspacePremium } from "react-icons/md";
import { BiSolidMessageDetail } from "react-icons/bi";
import { useSelector } from "react-redux";
import isEmailAllowed from "../../../../utils/isEmailAllowed";
import { LuLayoutDashboard } from "react-icons/lu";
import { PiUserList } from "react-icons/pi";
import { GoBlocked } from "react-icons/go";
import { HiOutlineClipboardDocumentCheck } from "react-icons/hi2";
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import { IoPeople } from "react-icons/io5";
import { FaGoogleDrive } from "react-icons/fa";
import { TbBrandGoogleAnalytics } from "react-icons/tb";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../../toolkit/slices/users/userSlice";
import { FaBoxes } from "react-icons/fa";
import { RiUserSettingsFill } from "react-icons/ri";
import { FaPhotoVideo } from "react-icons/fa";
import { TbReportSearch } from "react-icons/tb";
import { TbBrain } from "react-icons/tb";
import { MdInventory2, MdPersonAddAlt1 } from "react-icons/md";

let apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const data = [
  { tab: "Dashboard", src: "/dashboard", icon: <LuLayoutDashboard /> },
  { tab: "Analysis", src: "/analysis", icon: <TbBrandGoogleAnalytics /> },
  {
    tab: "Proposal Approvals",
    src: "/approvals",
    icon: <HiOutlineClipboardDocumentCheck />,
  },
  { tab: "Bookings", src: "/clients-bookings", icon: <PiUserList /> },
  {
    tab: "Premium Blocks",
    src: "/premiumBlockList",
    icon: <MdOutlineWorkspacePremium />,
  },
  {
    tab: "Blocked",
    src: "/blocked",
    icon: <GoBlocked className="icons-svg" />,
  },
  // {
  //   tab: "Chats",
  //   src: "/chats",
  //   icon: <BiSolidMessageDetail className="icons-svg" />,
  // },
  {
    tab: "Inventory Master",
    src: "/inventory-master",
    icon: <MdInventory2 className="icons-svg" />,
  },
  {
    tab: "Purchase Order",
    src: "/purchase-order",
    icon: <HiOutlineClipboardDocumentList className="icons-svg" />,
  },
  {
    tab: "Sales Order",
    src: "/sales-order",
    icon: <HiOutlineDocumentReport className="icons-svg" />,
  },
  {
    tab: "Billing",
    src: "/billing",
    icon: <HiOutlineDocumentCheck className="icons-svg" />,
  },
  {
    tab: "Reports",
    src: "/reports",
    icon: <TbReportSearch className="icons-svg" />,
  },
  {
    tab: "AI Reporting & Insights",
    src: "/ai-reporting-insights",
    icon: <TbBrain className="icons-svg" />,
  },
  {
    tab: "Asset Management",
    src: "/add-inventory",
    icon: <FaBoxes className="icons-svg" />,
  },
  {
    tab: "Client Management",
    src: "/client-management",
    icon: <RiUserSettingsFill className="icons-svg" />,
  },
  {
    tab: "Salesman Register",
    src: "/salesman-register",
    icon: <MdPersonAddAlt1 className="icons-svg" />,
  },
  {
    tab: "Drive",
    src: "/drive",
    icon: <FaGoogleDrive className="icons-svg" />,
  },
  {
    tab: "Mounting Proof",
    src: "/mounting-proof",
    icon: <FaPhotoVideo className="icons-svg" />,
  },
  {
    tab: "Permissions",
    src: "/permissions",
    icon: <IoPeople className="icons-svg" />,
  },
];

export const SideBarContainer = () => {
  const [activeTab, setActiveTab] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [mod, setMod] = useState([]);
  const [modulesLoading, setModulesLoading] = useState(true);
  const userEmail = useSelector((state) => state.user.email);
  const dispatch = useDispatch();
  const token = window.localStorage.getItem("token");
  // useEffect(() => {
  //     const currentPath = window.location.pathname;
  //     setActiveTab(currentPath);
  // }, []);

  useEffect(() => {
    // Fetch user permissions from the backend
    const fetchPermissions = async () => {
      try {
        const response = await fetch(
          `${apiBaseUrl}/inventoryManagement/getSpecificUserModules`,
          {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              authorization: `Token ${token}`,
            },
          }
        );
        const result = await response.json();
        if (result.success && result.allAccess) {
          setMod(data);
        } else if (result.success && result.data.length > 0) {
          const userPermissions = result.data[0].modules;

          // Filter modules based on user permissions
          const allowedModules = data.filter(
            (module) => userPermissions[module.tab]
          );
          setMod(allowedModules);
        }
      } catch (error) {
        console.error("Failed to fetch user permissions:", error);
      } finally {
        setModulesLoading(false);
      }
    };

    fetchPermissions();
  }, [modules]);

  useEffect(() => {
    checkAuthorization();
  }, [activeTab]);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };
  const handleSideBarCollapse = () => {
    setCollapsed((prev) => !prev);
  };
  const handleSideBarOpen = () => setCollapsed(false);
  const handleSideBarClose = () => setCollapsed(true);

  const checkAuthorization = async () => {
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/isUserAuthorized`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${token}`,
          },
        }
      );
      let responseJson = await response.json();
      if (!responseJson.success) {
        dispatch(logoutUser());
      }
    } catch (err) {
      console.log(`Error: ${err.message}`);
    }
  };
  return (
    <SideBarComponent
      data={mod}
      modulesLoading={modulesLoading}
      handleTabClick={handleTabClick}
      activeTabClick={activeTab}
      handleSideBarCollapse={handleSideBarCollapse}
      handleSideBarOpen={handleSideBarOpen}
      handleSideBarClose={handleSideBarClose}
      collapsed={collapsed}
    />
  );
};

export let modules = data
  .filter((ele) => ele.tab !== "Permissions")
  .map((ele) => ele.tab);

export let linkBasedModule = data;
